import React, { useEffect, useState } from "react";
import { Card, Typography, Button, Modal, message, Spin } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import ContactForm from "./ContactForm";

const { Title } = Typography;

const ContactList = () => {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    fetchContactInfo();
  }, []);

  // ✅ Fetch Contact Info
  const fetchContactInfo = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/contactInfo");
      setContact(response.data);
    } catch (error) {
      message.error("Failed to load contact info.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Open Modal for Editing
  const handleEdit = () => {
    setFormData(contact); // Pass existing contact data
    setModalVisible(true);
  };

  // ✅ Open Modal for Adding New Contact Info
  const handleAdd = () => {
    setFormData(null); // Reset form for new entry
    setModalVisible(true);
  };

  return (
    <Card
      style={{
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Title level={4} style={{ color: "#0c8c49" }}>Contact Information</Title>

      {loading ? (
        <Spin size="large" />
      ) : contact ? (
        <>
          <p><strong>Title:</strong> {contact.title}</p>
          <p><strong>Description:</strong> {contact.description}</p>
          <p><strong>Phone:</strong> {contact.phone}</p>
          <p><strong>Email:</strong> {contact.email}</p>
          <p><strong>Location:</strong> {contact.location}</p>

          {/* ✅ Edit Button */}
          <Button
            icon={<EditOutlined />}
            onClick={handleEdit}
            style={{
              backgroundColor: "#ffaa00",
              borderColor: "#ffaa00",
              color: "#fff",
              marginTop: "10px",
            }}
          >
            Edit
          </Button>
        </>
      ) : (
        <>
          <p>No contact information available.</p>
          {/* ✅ Add Button (Only when no contact info exists) */}
          <Button
            icon={<PlusOutlined />}
            onClick={handleAdd}
            type="primary"
            style={{
              backgroundColor: "#0c8c49",
              borderColor: "#0c8c49",
              marginTop: "10px",
            }}
          >
            Add Contact Info
          </Button>
        </>
      )}

      {/* ✅ Contact Form Modal */}
      <Modal
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        destroyOnClose
      >
        <ContactForm
          formData={formData} // Pass data for editing or leave empty for new entry
          setFormData={setFormData}
          refetchData={fetchContactInfo}
          closeModal={() => setModalVisible(false)}
        />
      </Modal>
    </Card>
  );
};

export default ContactList;
